<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索老師名稱|聯絡電話|聯絡電郵" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加老師</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="老師名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索老師名稱"></el-input>
						</el-form-item>

						<el-form-item label="聯絡電話" class="mb-0">
							<el-input size="small" v-model="from.phone" placeholder="搜索聯絡電話"></el-input>
						</el-form-item>
						
						<el-form-item label="聯絡電郵" class="mb-0">
							<el-input size="small" v-model="from.email" placeholder="搜索聯絡電郵"></el-input>
						</el-form-item>
						
						<el-form-item label="學校名稱" class="mb-0">
							<el-input size="small" v-model="from.school_name" placeholder="搜索學校名稱"></el-input>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" @sort-change="sortChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
				
				<el-table-column align="center" prop="name" label="老師名稱" sortable="custom">
				</el-table-column>

				<el-table-column align="center" prop="phone" label="聯絡電話">
				</el-table-column>
				
				<el-table-column align="center" prop="email" label="聯絡電郵">
				</el-table-column>
				
				<el-table-column align="center" prop="school_name" label="學校名稱" sortable="custom">
				</el-table-column>
				
				<el-table-column align="center" prop="remark" label="備註" show-overflow-tooltip>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" label="創建時間" sortable="custom" width="180">
				</el-table-column>
				
				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改老師' : '添加老師'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'120px'">
				
				<el-form-item label="老師名稱" prop="name">
					<el-input v-model="form.name" placeholder="老師名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="聯絡電話" prop="phone">
					<el-input v-model="form.phone" placeholder="聯絡電話" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="聯絡電郵" prop="email">
					<el-input v-model="form.email" placeholder="聯絡電郵" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="備註" prop="remark">
					<el-input v-model="form.remark" type="textarea" :rows="3" placeholder="備註" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="選擇學校" prop="school_id">
					<el-select
						size="small" style="width: 85%;"
						v-model="form.school_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學校編號 - 學校地區 - 學校名稱"
						:remote-method="remoteMethodSchool"
						:loading="loading">
						<el-option
						v-for="item in schoolOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					phone: '',
					email: '',
					school_name: '',
				},
				auth_val: 'Teacher',
				preUrl: "data/teacherList", //列表地址
				delAllUrl: "data/delTeacherAll", //批量删除地址
				delUrl: "data/delTeacher", //删除單条地址
				addUrl: "data/addTeacher", //添加/修改地址

				tableData: [],
				schoolOptions: [],
				loading: false,
				form: {
					id:0,
					name: "",
					phone: '',
					email: '',
					remark: '',
					school_id: null
				},
				rules: {
					name: [{
							required: true,
							message: "老師名稱不能為空",
							trigger: 'blur',
						},
					],
					phone: [{
							required: true,
							message: "聯絡電話不能為空",
							trigger: 'blur',
						},
					],
					email: [{
							required: true,
							message: "聯絡電郵不能為空",
							trigger: 'blur',
						},
						{
							type: 'email',
							message: "請輸入正確的郵箱格式",
							trigger: 'blur',
						},
					],
					school_id: [{
							required: true,
							message: "請選擇學校",
							trigger: 'blur',
						},
					],
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']),
		},
		created() {
		},
		methods: {
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
					}
				})
			},
			remoteMethodSchool(query){
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getSchoolList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.schoolOptions = all.data;
						this.loading = false;
					}).catch(err => {
						this.schoolOptions = [];
						this.loading = false;
					})
				} else {
					this.schoolOptions = [];
					this.loading = false;
				}
			},
			// 打开模态框
			openModel(e = false) {
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: "",
						phone: '',
						email: '',
						remark: '',
						school_id: null
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						phone: e.row.phone,
						email: e.row.email,
						remark: e.row.remark || '',
						school_id:e.row.school_id,
					}
					// 加载当前学校信息到选项列表
					if(e.row.str_school) {
						this.schoolOptions = [{id:e.row.school_id,str_name:e.row.str_school}]
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					phone: '',
					email: '',
					school_name: '',
				}
				this.page.current = 1;
				this.search = ''
				this.prop = 'create_time'
				this.sort = 'descending'
				this.getList()
			},
			// 排序变化
			sortChange(column) {
				if(column.prop) {
					this.prop = column.prop
					this.sort = column.order === 'ascending' ? 'asc' : 'desc'
					this.getList()
				}
			},
		}
	}
</script>

<style>
</style>

